import { CloseIcon } from 'src/domains/layouts/shared/assets/icons/CloseIcon';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { css, SerializedStyles } from '@emotion/react';

interface YouDecideExitWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setYouDecideExitWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            justify-content: center;
            width: 80px;
            height: 32px;
            background: ${theme.star.rabHeading.bgColorTertiary};
            border-radius: ${theme.star.radius.small};
            font-size: ${theme.star.fontSize.small};
        `;
    }
    return css`
        line-height: 1.43;
        font-size: ${theme.star.fontSize.xRegular};
    `;
};

export const YouDecideExitWrapper = withConfig(theme => styled('div', { label: 'YouDecideExitWrapper' })<YouDecideExitWrapperPropsType>`
    ${({ variant }): SerializedStyles => setYouDecideExitWrapper(variant, theme)}
    align-items: center;
    cursor: pointer;
    display: flex;
    font-weight: ${theme.star.fontWeight.bold};
`);


interface RabCloseIconWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const RabCloseIconWrapper = styled(CloseIcon, { label: 'RabCloseIconWrapper' })<RabCloseIconWrapperPropsType>`
    display: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none' : 'block'};
    fill: currentcolor;
    margin: -2px 14px 0 8px;
    width: 20px;
`;

